import React, { useState, useEffect } from "react";
import { PlusOutlined } from "@ant-design/icons";
import { Button, Form, Input, Upload, message, Slider, Select } from "antd";
import personaApi from "./persona.api";
import axios from "axios";

const { TextArea } = Input;

const getVariantsForVoice = (voices, displayName) => {
  return voices.find((v) => v.displayName === displayName)?.variants || [];
};

const AddPersona = ({
  isEdit,
  setModalOpen,
  fetchPersonas,
  profiles,
  persona,
  form,
  modalOpen,
}) => {
  const [fileList, setFileList] = useState([]);
  const [voices, setVoices] = useState([]);
  const [filteredStyles, setFilteredStyles] = useState([]);
  const [selectedVoiceVariants, setSelectedVoiceVariants] = useState([]);

  useEffect(() => {
    console.log("AddPersona received:", { isEdit, persona });
  }, [isEdit, persona]);

  const normFile = (e) => {
    if (Array.isArray(e)) return e;
    return e?.fileList;
  };

  const handleFileChange = ({ fileList: newFileList }) => {
    setFileList(newFileList.slice(-1));
  };

  const handleSubmit = async (values) => {
    try {
      console.log("styleDegree raw value before append:", values.styleDegree);
      const isUploadingNewFile =
        fileList.length > 0 && fileList[0].originFileObj;

      let response;

      if (isEdit && !isUploadingNewFile) {
        values.styleDegree = parseFloat((values.styleDegree / 100).toFixed(2));

        const selectedDisplayName = values.displayName;
        const selectedLanguage = values.language;

        const selectedVoice = voices.find((v) => v.displayName === selectedDisplayName);
        const variants = selectedVoice?.variants || [];

        const matchingVariant = variants.find((v) => v.Locale === selectedLanguage);

        values.shortName =
          matchingVariant?.ShortName || variants[0]?.ShortName || persona.shortName || "en-GB-SoniaNeural";
        values.voiceStyle = values.voiceStyle || persona.voiceStyle || "";
        values.language = selectedLanguage || persona.language || "en-GB";
        values.pitch = parseFloat(values.pitch) || persona.pitch || 1;
        values.rate = parseFloat(values.rate) || persona.rate || 1;
        values.volume = parseFloat(values.volume) || persona.volume || 10;

  response = await personaApi.updatePersona(persona._id, values);
}

 
 else {
        const formData = new FormData();

        formData.append("name", values.name);
        formData.append("description", values.description);
        formData.append("customInstructions", values.customInstructions);
        formData.append("displayName", values.displayName);

        const matching = selectedVoiceVariants.find(
          (v) => v.Locale === values.language
        );

        const shortName =
          matching?.ShortName || selectedVoiceVariants[0]?.ShortName || "";

        formData.append("shortName", shortName);
        formData.append("voiceStyle", values.voiceStyle || "");
        formData.append("language", "en-GB");
        formData.append("pitch", isNaN(values.pitch) ? "" : values.pitch.toString());
        formData.append("rate", isNaN(values.rate) ? "" : values.rate.toString());
        formData.append("volume", isNaN(values.volume) ? "" : values.volume.toString());
        formData.append("styleDegree", (values.styleDegree / 100).toFixed(2));

        if (isUploadingNewFile) {
          formData.append("profile", fileList[0].originFileObj);
        } else if (!isEdit) {
          message.error("Avatar upload is required.");
          return;
        }

        response = isEdit
          ? await personaApi.updatePersona(persona._id, formData)
          : await personaApi.createPersona(formData);
      }

      if (response.status === 200 || response.status === 201) {
        message.success(`Profile ${isEdit ? "updated" : "created"} successfully`);
        onCancel();
        fetchPersonas();
      } else {
        message.error("Failed to submit profile.");
      }
    } catch (error) {
      console.error("Submit error:", error);
      message.error("Failed to submit profile.");
    }
  };

  const onCancel = () => {
    setModalOpen(false);
    setFileList([]);
    form.resetFields();
    form.setFieldsValue({
      pitch: 0,
      rate: 0,
      volume: 0,
      styleDegree: 100,
    });
  };

  useEffect(() => {
    if (isEdit && persona) {
      form.setFieldsValue({
        name: persona.name,
        description: persona.description,
        customInstructions: persona.customInstructions,
        displayName: persona.displayName || "",
        voiceStyle: persona.voiceStyle,
        pitch: parseInt(persona.pitch?.toString().replace("%", "")) || 0,
        rate: parseInt(persona.rate?.toString().replace("%", "")) || 0,
        volume: parseInt(persona.volume?.toString().replace("%", "")) || 0,
        styleDegree: Math.round((parseFloat(persona.styleDegree) || 1.0) * 100),
      });

      if (persona.profile) {
        setFileList([
          {
            uid: "-1",
            name: "profile.png",
            status: "done",
            url: `https://admin.comfortcompanions.co.uk${persona.profile}`,
          },
        ]);
      }

      if (voices.length > 0) {
        const matchedVoice = voices.find((v) =>
          v.variants.some((variant) => variant.ShortName === persona.shortName)
        );

        const variants = matchedVoice?.variants || [];
        const styles = Array.from(
          new Set(variants.flatMap((v) => v.StyleList || []))
        );
        setFilteredStyles(styles);
      }
    }
  }, [persona, isEdit, voices]);

  useEffect(() => {
    const fetchVoices = async () => {
      try {
        const res = await axios.get(
          "https://admin.comfortcompanions.co.uk/api/audio/voices"
        );
        const rawVoices = res.data;

        const grouped = rawVoices.reduce((acc, voice) => {
          const key = voice.DisplayName;
          if (!acc[key]) acc[key] = [];
          acc[key].push(voice);
          return acc;
        }, {});

        const voiceOptions = Object.entries(grouped).map(([name, variants]) => {
          const isMultilingual = variants.length > 1;
          return {
            label: isMultilingual ? `${name} Multilingual` : name,
            displayName: name,
            variants,
          };
        });

        setVoices(voiceOptions);

        if (!isEdit) {
          form.setFieldsValue({
            pitch: 0,
            rate: 0,
            volume: 0,
            styleDegree: 100,
          });
        }
      } catch (error) {
        console.error("Error fetching Azure voices:", error);
      }
    };

    fetchVoices();
  }, []);

  return (
    <Form
      form={form}
      onFinish={handleSubmit}
      layout="vertical"
      className="persona-form"
    >
      <Form.Item
        label="Name"
        name="name"
        rules={[{ required: true, message: "Please enter name" }]}
      >
        <Input />
      </Form.Item>

      <Form.Item
        label="Description"
        name="description"
        rules={[{ required: true, message: "Please enter description" }]}
      >
        <TextArea />
      </Form.Item>

      <Form.Item
        label="Custom Instructions"
        name="customInstructions"
        rules={[{ required: true, message: "Please enter custom instructions" }]}
      >
        <TextArea />
      </Form.Item>

      <Form.Item
        label={
          <span>
            <span style={{ color: "red" }}>*</span>{" "}
            <span style={{ color: "black" }}>Upload Avatar</span>
          </span>
        }
        valuePropName="profile"
        getValueFromEvent={normFile}
      >
        <Upload
          listType="picture-card"
          fileList={fileList}
          onChange={handleFileChange}
          beforeUpload={() => false}
        >
          {fileList.length < 1 && (
            <div>
              <PlusOutlined />
              <div style={{ marginTop: 8 }}>Upload</div>
            </div>
          )}
        </Upload>
      </Form.Item>

      <Form.Item label="Voice Name" name="displayName">
        <Select
          showSearch
          placeholder="Select a voice"
          optionFilterProp="children"
          onChange={(value) => {
            const selected = voices.find((v) => v.displayName === value);
            if (selected) {
              const variants = selected.variants;
              const styles = Array.from(
                new Set(variants.flatMap((v) => v.StyleList || []))
              );

              setSelectedVoiceVariants(variants);
              setFilteredStyles(styles);

              form.setFieldsValue({
                language: undefined,
                voiceStyle: undefined,
              });
            }
          }}
        >
          {voices.map((voice) => (
            <Select.Option key={voice.displayName} value={voice.displayName}>
              {voice.label}
            </Select.Option>
          ))}
        </Select>
      </Form.Item>

      <Form.Item label="Voice Style" name="voiceStyle">
        <Select allowClear disabled={filteredStyles.length === 0}>
          {filteredStyles.map((style) => (
            <Select.Option key={style} value={style}>
              {style}
            </Select.Option>
          ))}
        </Select>
      </Form.Item>

      <Form.Item label="Pitch" name="pitch" valuePropName="value">
        <Slider min={-50} max={50} step={1} tooltip={{ formatter: (val) => `${val}%` }} />
      </Form.Item>

      <Form.Item label="Rate" name="rate" valuePropName="value">
        <Slider min={-50} max={100} step={1} tooltip={{ formatter: (val) => `${val}%` }} />
      </Form.Item>

      <Form.Item label="Volume Change" name="volume" valuePropName="value">
        <Slider min={-100} max={100} step={1} tooltip={{ formatter: (val) => `${val}%` }} />
      </Form.Item>

      <Form.Item label="Style Degree" name="styleDegree" valuePropName="value">
        <Slider min={1} max={200} step={1} tooltip={{ formatter: (val) => `${val}%` }} />
      </Form.Item>

      <Form.Item>
        <div className="form-footer">
          <Button onClick={onCancel}>
            Cancel
          </Button>
          <Button type="primary" htmlType="submit">
            Submit
          </Button>
        </div>
      </Form.Item>
    </Form>
  );
};

export default AddPersona;
